module.exports = {
  gameDemoToken: "AKIAJc11428d5JNCQZ4S5MDE5MFA",
  footerText: 'Copyright Tokkenz MoneyHunt Games, Inc. ©'
}
